import { render, staticRenderFns } from "./NetworkStatusLink.vue?vue&type=template&id=bc19400e&"
import script from "./NetworkStatusLink.vue?vue&type=script&lang=js&"
export * from "./NetworkStatusLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports